import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IWorkbookParentInfo } from '../models/IWorkbookInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Views } from '../resources/Views';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ViewErrors } from './ViewErrors';

interface IConfirmDeleteViewsScope extends ng.IScope {
    deleteViewsConfirmation: string;
    deleteWorkbooksConfirmation: string;
}

export class HideViewsAction {

  public static $inject = ['ViewErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'Views'];

  constructor(
    private ViewErrors: ViewErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private Views: Views) { }

  public confirmDeleteViews(views: Set<IViewInfo>, context: IActionContext): ng.IPromise<IResult> {
    const scope = <IConfirmDeleteViewsScope> context.scope;
    const workbooksToDelete = HideViewsAction.determineWorkbooksToBeDeleted(views);

    scope.deleteViewsConfirmation = this.$translate.instant('confirmDeleteViews', {
      VIEW_COUNT: views.size(),
      VIEW_NAME: L10n.elideIfLong(views.first().name)
    }, L10n.Interpolations.Count);

    scope.deleteWorkbooksConfirmation = workbooksToDelete.length > 0
      ? this.$translate.instant('confirmDeleteViewsWorkbookWarning', {
          WORKBOOK_COUNT: workbooksToDelete.length,
          WORKBOOK_NAME: L10n.elideIfLong(workbooksToDelete[0].name)
        }, L10n.Interpolations.Count)
      : null;

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyTemplateUrl: 'confirmDeleteViews.html',
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: views.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Views.hide(views.keys()).then(
          (result: IResult) => this.notifyResult(views, result));
      }
    }).result;
  }

  // Determine if any workbooks will be deleted as a result of deleting the selected views
  public static determineWorkbooksToBeDeleted(views: Set<IViewInfo | IViewDetailInfo>): IWorkbookParentInfo[] {
    const workbooksToDelete: IWorkbookParentInfo[] = [];
    const workbookViewCount: _.Dictionary<number> = {};
    views.each((view: IViewInfo) => {
      let viewCount = workbookViewCount[view.workbook.id] || 0;
      viewCount++;
      if (viewCount === view.workbook.numSheets) {
        workbooksToDelete.push(view.workbook);
      }
      workbookViewCount[view.workbook.id] = viewCount;
    });
    return workbooksToDelete;
  }

  private notifyResult(views: Set<IViewInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      views,
      {
        successId: 'deleteViewsSuccess',
        errorId: 'deleteViewsError'
      },
      (errorItem: IErrorItem<IViewInfo>) => this.ViewErrors.errorDetailsFor(errorItem))(result);
  }

}

Module.instance().service('HideViewsAction', HideViewsAction);
